var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81498 4.54034C1.12389 5.84359 0.861979 7.3446 1.06896 8.81585C1.27594 10.2871 1.94051 11.6484 2.96196 12.6933C3.9834 13.7383 5.30601 14.4099 6.72932 14.6065C8.15262 14.803 9.59902 14.5138 10.8493 13.7826C12.0995 13.0513 13.0854 11.918 13.6575 10.5543C14.2297 9.19067 14.3569 7.67105 14.0198 6.22582C13.6828 4.78058 12.8998 3.48853 11.7897 2.5455C10.6796 1.60247 9.30284 1.05989 7.8681 1L7.31509 3.37681",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 5.41699L7.30641 7.93548",
    stroke: "#596475",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeDuration);
export default __webpack_public_path__ + "static/media/recipe_duration.3241c15614ff1deff5010ab6dd71eaee.svg";
export { ForwardRef as ReactComponent };